<template>
    <layout title="Daily Balance Activity">
        <daily-balance-listings :balance="balance" :items="items"></daily-balance-listings>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import DailyBalanceListings from "@/Components/DailyBalances/DailyBalanceListings";

export default {
    components: {DailyBalanceListings, Layout},
    props: {
        balance: {
            type: Object,
            default: {
                current_balance: 0
            }
        },
        items: {
            type: Array,
            default: []
        },
    },
}
</script>
